const userMenu = {
  personalAccount: "Личный аккаунт",
  businessAccount: "Бизнес аккаунт",
  profile: "Мой профиль",
  settings: "Настройки",
  signOut: "Выйти",
  switchAccount: "Сменить аккаунт",
  online: "Онлайн",
  role: "Роль",
  admin: "Админ",
  member: "Участник",
  viewer: "Наблюдатель",
} as const;
export default userMenu;
